class OrderConfirmationOrderInformationComponentController {
    constructor(settings) {
        this.settings = settings;
    }

    $onInit() {
        if (!this.order || !this.order.Order) return;

        this.orderInfo = this.getOrderInfo();
        this.dateInfo = this.getDateInfo();
        this.addressInfo = this.getAddressInfo();
        this.storeInfo = this.getStoreInfo();
    }

    getOrderInfo() {
        return {
            method: this.order.Order.DeliveryMethod,
            headerTexts: this.getHeaderTexts(),
            canLeaveUnattended: this.order.CanLeaveOrderUnattended,
            instructions: this.order.Order.DeliveryInstructions,
        };
    }

    getHeaderTexts() {
        return {
            delivery: this.settings.orderConfirmation.courierDeliveryDetailsHeader,
            express: this.settings.orderConfirmation.expressDeliveryDetailsHeader,
            pickup: this.settings.orderConfirmation.pickupDeliveryDetailsHeader,
        };
    }

    getDateInfo() {
        return {
            date: this.order.Order.DeliveryDate,
            startTime: this.order.Order.DeliveryStartTime,
            endTime: this.order.Order.DeliveryEndTime,
            minutesRemainingUntilExpressDelivery: this.order.Order.MinutesRemainingUntilExpressDelivery,
        };
    }

    getAddressInfo() {
        return {
            street1: this.order.Order.DeliveryStreet1,
            street2: this.order.Order.DeliveryStreet2,
            suburb: this.order.Order.DeliverySuburb,
            postcode: this.order.Order.DeliveryPostalCode,
        };
    }

    getStoreInfo() {
        if (this.order.Order.DeliveryMethod !== 'Pickup') return null;

        return {
            name: this.order.Order.PickUpStoreName,
            tradingHours: this.order.TradingHours,
            details: this.order.Store,
        };
    }
}

OrderConfirmationOrderInformationComponentController.$inject = ['Settings'];

const orderConfirmationOrderInformaionComponentDefinition = {
    bindings: {
        order: '<',
    },
    controller: OrderConfirmationOrderInformationComponentController,
    template: `
        <wow-order-information
            order-info="::$ctrl.orderInfo"
            date-info="::$ctrl.dateInfo"
            address-info="::$ctrl.addressInfo"
            store-info="::$ctrl.storeInfo"
            is-guest="false">
        </wow-order-information>
        <wow-order-information-tips
            order-method="::$ctrl.orderInfo.method">
        </wow-order-information-tips>
    `,
};

module.exports = {
    OrderConfirmationOrderInformationComponentController,
    orderConfirmationOrderInformaionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-order-information.component.js